import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormControl from '../base/FormControl';
import Radio from '../base/Radio';
import { AppContext } from '../../../context/AppContext';
import { FormikConsumer } from 'formik';
import Time from '../base/Time';

class HourWidget extends Component {
  static contextType = AppContext;

  applyHours(source, targets, values, setFieldValue) {
    const sourceFrom = values['hours_' + source + '_from'];
    const sourceTo = values['hours_' + source + '_to'];

    targets.forEach((day) => {
      setFieldValue('hours_' + day + '_from', sourceFrom);
      setFieldValue('hours_' + day + '_to', sourceTo);
    });
  }

  clearHour(day, setFieldValue) {
    setFieldValue('hours_' + day + '_from', '');
    setFieldValue('hours_' + day + '_to', '');
  }

  renderHourRows = (values, setFieldValue) => {
    return (
      ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day, index) =>
        <tr key={index}>
          <td>{day}</td>
          <td>
            <Time name={'hours_' + day.toLowerCase() + '_from'} type="time" />
          </td>
          <td>
            <Time name={'hours_' + day.toLowerCase() + '_to'} type="time" />
          </td>
          <td>
            {index === 0 &&
              <button type="button" className="usa-button" onClick={() => {
                this.applyHours('monday', ['tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'], values, setFieldValue)
              }}>Mon - Sun</button>
            }
            {index === 0 &&
              <button type="button" className="usa-button" onClick={() => {
                this.applyHours('monday', ['tuesday', 'wednesday', 'thursday', 'friday'], values, setFieldValue)
              }}>Mon - Fri</button>
            }
            <button type="button" className="usa-button" onClick={() => {
              this.clearHour(day.toLowerCase(), setFieldValue)
            }}>Clear
            </button>
          </td>
        </tr>
      )
    )
  };

  render() {
    return (
      <FormikConsumer>
        {({ values, setFieldValue, errors, touched }) => (
          <FormControl label="Hours of Operation"
            required={true}>
            <Radio name="contact_hours"
              onChangeCallback={this.contactHoursChange}
              options={[
                { label: 'Contact Organization for hours of operation', value: '1' },
                { label: 'Hours', value: '0' }
              ]} />

            {values['contact_hours'] === '0' &&
              <div className="hour-vary-widget">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>From (09:00 AM)</th>
                      <th>To (05:00 PM)</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderHourRows(values, setFieldValue)}
                  </tbody>
                </table>
              </div>
            }
          </FormControl>
        )}
      </FormikConsumer>
    )
  }
}

HourWidget.defaultProps = {
  call_for_hours: false,
};

HourWidget.propTypes = {
  call_for_hours: PropTypes.bool,
};

export default HourWidget;
